/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ModelKeyProvider, LocaleProvider } from '@typescript-kit/core';
import { DataModelKey } from './key/data-model.key';
import { Entity } from './model/entity.model';

// DYNAMIC IMPORT IS NOT WORKING WITH COMMONJS MODULE RESOLUTION
import { dataDeLocale } from './locale/de.locale';
import { dataEnLocale } from './locale/en.locale';

export class DataInitializer {

  static initialize() {
    DataInitializer.registerModelKeys();
    DataInitializer.registerLocales();
  }

  static registerModelKeys() {
    ModelKeyProvider.registerKey(Entity, DataModelKey.ENTITY);
  }

  static registerLocales() {
    LocaleProvider.registerPackageLocale('de', 'kit-data', dataDeLocale);
    LocaleProvider.registerPackageLocale('en', 'kit-data', dataEnLocale);
    // LocaleProvider.registerPackageLocale('de', 'kit-data', async () => {
    //   return import('./locale/de.locale').then((mod) => mod.dataDeLocale);
    // });
    // LocaleProvider.registerPackageLocale('en', 'kit-data', async () => {
    //   return import('./locale/en.locale').then((mod) => mod.dataEnLocale);
    // });
  }

}
